import { FC, ReactNode, memo } from 'react'

import { s } from './styles'

type Props = {
  title: string
  rows: { label: ReactNode; value: ReactNode }[]
}

export const CashInOut: FC<Props> = memo(({ title, rows }) => (
  <s.Box rounded shadowed>
    <s.Title>{title}</s.Title>
    <div>
      {rows.map((item, index) => (
        <s.Row key={index}>
          <s.Label>{item.label}</s.Label>
          <span>{item.value}</span>
        </s.Row>
      ))}
    </div>
  </s.Box>
))
